<ion-header>
    <ion-toolbar color="dark">
        <ion-buttons slot="start">
            <ion-button (click)="closeModal()">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons *ngIf="canDelete" slot="end" class="btns-right">
            <ion-button (click)="removeItem()">
                <ion-icon slot="icon-only" name="trash"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>
<ion-content [forceOverscroll]="false" color="dark" [fullscreen]="true">
    <swiper-container *ngIf="isImage" zoom="true">
        <swiper-slide>
            <div class="swiper-zoom-container">
                <img [src]="imgSource" />
            </div>
            <div *ngIf="description" class="description">
                {{ description }}
            </div>
        </swiper-slide>
    </swiper-container>
    <div *ngIf="isVideo" class="video-container">
        <video autoplay controls [src]="safeUrl"></video>
        <div *ngIf="description" class="description">
            {{ description }}
        </div>
    </div>
</ion-content>
